export type activeDirType = (typeof activeDirType)[keyof typeof activeDirType];
export const activeDirType = {
  rtl: 'rtl',
  ltr: 'ltr',
} as const;
export type activeModeType = (typeof activeModeType)[keyof typeof activeModeType];
export const activeModeType = {
  light: 'light',
  dark: 'dark',
} as const;
export type isLayoutType = (typeof isLayoutType)[keyof typeof isLayoutType];
export const isLayoutType = {
  boxed: 'boxed',
  full: 'full',
} as const;
export type activeThemeType = (typeof activeThemeType)[keyof typeof activeThemeType];
export const activeThemeType = {
  BLUE_THEME: 'BLUE_THEME',
  GREEN_THEME: 'GREEN_THEME',
  BLACK_THEME: 'BLACK_THEME',
  PURPLE_THEME: 'PURPLE_THEME',
  ORANGE_THEME: 'ORANGE_THEME',
} as const;
